import { render, staticRenderFns } from "./takeaway-food.vue?vue&type=template&id=066b3463&scoped=true&"
import script from "./takeaway-food.vue?vue&type=script&lang=js&"
export * from "./takeaway-food.vue?vue&type=script&lang=js&"
import style0 from "./takeaway-food.vue?vue&type=style&index=0&id=066b3463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b3463",
  null
  
)

export default component.exports